<div #divSpinnerAutoevaluacion class="cargandoModal" [style.display]="cargando ? '' : 'none'">
    <mat-spinner style="margin:0 auto; margin-top: 15%;"></mat-spinner>
</div>

<div *ngIf="!cargando">


    <button class="btn-volver" mat-raised-button (click)=irA()>              
        Volver
    </button>

    <div class="projects">
        <div class="card">
            <div class="card-header header-background">
                <p class="welcome-title">Guía de Evaluación <i style="color: #EE366D;" *ngIf="dataJardin.etapaJardin===1">Modo Entrenamiento</i> </p>
            </div>

            <div class="card-body">
                <div class="row" *ngIf="dataJardin.etapaJardin<=2">
                    <div class="col-sm-6">
                        <button class="btn-guardar" mat-raised-button (click)="guardar()" [disabled]="this.dataJardin.etapaJardin > 2">
                            Guardar
                        </button>
                        <button class="btn-finalizar" *ngIf="finalizarAutoEvaluacion" mat-raised-button [disabled]="finalizarAutoEvaluacion">
                            Finalizar y Enviar
                        </button>
                        <button class="btn-volver" style="margin-left: 5px;" *ngIf="!finalizarAutoEvaluacion" mat-raised-button (click)="finalizar()">
                            Finalizar y Enviar
                        </button>
                    </div>
                    <div class="col-sm-6" style="text-align: right;">
                        <label class="texto" style="font-size: 10px; text-align: right;
                            font: normal normal 600 14px/18px Montserrat;
                            letter-spacing: 0px;
                            color: #30374B;
                            text-transform: uppercase;
                            opacity: 1;">ESTADO DE GUÍA DE EVALUACIÓN:</label>
                        <span class="span-estadoPrueba">  
                            <label class="estado" style="text-align: left;
                            font: normal normal bold 16px/19px Montserrat;
                            letter-spacing: 0px;
                            color: #3A445E;
                            opacity: 1;">En curso</label>
                        </span>
                    </div>
                </div>



                <div class="row">
                    <div class="col-sm-6">
                        <div style="background: #F5F6FC 0% 0% no-repeat padding-box;
                        border-radius: 10px;
                        opacity: 1; margin-top: 15px;padding: 5px 30px;">
                            <p style="text-align: left;
                            font: normal normal bold 16px/53px Montserrat;
                            letter-spacing: 0px;
                            color: #30374B;
                            opacity: 1;">Sobre su Guía de Evaluación</p>

                            <p style="text-align: left;
                        letter-spacing: 0px;
                        color: #30374B;
                        opacity: 1;">La Guía de Evaluación de este jardín infantil se encuentra en espera (no posee información en todos los elementos de gestión que la componen). Considere que debe completar TODO lo requerido para enviar su Guía de Evaluación.
                                Revise el resumen de elemento(s) de gestión y medio(s) de verificación asociado(s) (sección a su derecha) para identificar lo que pueda estar faltando.</p>
                        </div>
                    </div>
                    <div class="col-sm-6" style="text-align: right;">
                        <div style="background: #F5F6FC 0% 0% no-repeat padding-box;border-radius: 10px; opacity: 1;margin-top: 15px;padding: 5px 30px;">
                            <p style="text-align: left;font: normal normal bold 16px/53px Montserrat;letter-spacing: 0px;color: #30374B;opacity: 1;">Resumen</p>
                            <p style="text-align: left;letter-spacing: 0px;color: #30374B;opacity: 1;">
                                Presione el botón para revisar el resumen de los Elementos de Gestión y los Medios de Verificación que haya subido.
                            </p>
                            <button class="btn-guardar" mat-raised-button (click)="verResumen()">
                                REVISAR
                            </button>
                        </div>
                    </div>
                </div>





                <mat-tab-group animationDuration="0ms" class="tabs-autoevaluacion mt-2" (selectedTabChange)="tabChanged($event)">
                    <mat-tab *ngFor="let area of autoEvaluacion; let a = index">
                        <ng-template mat-tab-label>
                            <div class="num-tab">
                                <label>{{area.nombre}}</label>
                                <!-- <div [ngClass]=" 
                                {'estado-autoevaluacion':true,
                                'estadoDiv':true,
                                'estado-pendiente': area.finalizado === 0,
                                'estado-enCurso': area.finalizado === 1, 
                                'estado-finalizado': area.finalizado === 2}"></div> -->
                            </div>
                            <div class="texto-tab">{{area.area | slice:3}}</div>
                        </ng-template>

                        <p *ngIf="numTabSelected === 0" class="tabsSection area1">12 Elementos de Gestión</p>
                        <p *ngIf="numTabSelected === 1" class="tabsSection area2">22 Elementos de Gestión</p>
                        <p *ngIf="numTabSelected === 2" class="tabsSection area3">8 Elementos de Gestión</p>
                        <p *ngIf="numTabSelected === 3" class="tabsSection area4">16 Elementos de Gestión</p>
                        <p *ngIf="numTabSelected === 4" class="tabsSection area5">8 Elementos de Gestión</p>
                        <p *ngIf="numTabSelected === 5" class="tabsSection area6">5 Elementos de Gestión</p>

                        <div class="contenedor-acordeon">
                            <mat-accordion class="acordeon" *ngFor="let dimension of area.dimensiones; let d = index">
                                <mat-expansion-panel hideToggle="true" #acordeonDimension>
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <span [ngClass]=" 
                                            {'estado-autoevaluacion':true,
                                            'estado-pendiente': dimension.finalizado === 0,
                                            'estado-enCurso': dimension.finalizado === 1, 
                                            'estado-finalizado': dimension.finalizado === 2}"></span>
                                            <div>
                                                <h4>{{dimension.dimension}}</h4>
                                                <label>{{dimension.elementos.length}} elementos de gestión</label>
                                            </div>
                                        </mat-panel-title>
                                        <mat-panel-description>
                                            <img style="width: 40px;" *ngIf="!acordeonDimension.expanded" src="../../../.././../../assets/icons/JUNJI__green-plus.svg">
                                            <img style="width: 40px;" *ngIf="acordeonDimension.expanded" src="../../../.././../../assets/icons/JUNJI__green-less.svg">
                                        </mat-panel-description>
                                    </mat-expansion-panel-header>

                                    <div *ngFor="let elemento of dimension.elementos; let e = index">
                                        <div class="pregunta">
                                            {{elemento.nombreCorto}} {{elemento.elementoGestion}}
                                        </div>

                                        <mat-radio-group required aria-labelledby="example-radio-group-label" class="example-radio-group radio-autoevaluacion" *ngIf="area.nombre!='6'" [disabled]="this.dataJardin.etapaJardin > 2">
                                            <table class="respuestas">
                                                <tr>
                                                    <td *ngFor="let retroAlimentacion of elemento.retroAlimentacion; let r = index" [className]="retroAlimentacion.seleccionada? 'td-selected' : ''">

                                                        <mat-radio-button (click)="alternativaSeleccionada(a,d,e,r)" class="example-radio-button div-radio" [value]="retroAlimentacion.idRetroAlimentacion" [id]="retroAlimentacion.idRetroAlimentacion" [checked]="retroAlimentacion.seleccionada" *ngIf="dataJardin.etapaJardin<=2"
                                                            [disabled]="this.dataJardin.etapaJardin > 2">
                                                            <span class="span-nombre">{{textoRetroAlimentacion[r]}}</span>
                                                            <span class="span-nota">{{retroAlimentacion.nota}}</span>
                                                        </mat-radio-button>
                                                        <mat-radio-button class="example-radio-button div-radio" [value]="retroAlimentacion.idRetroAlimentacion" [id]="retroAlimentacion.idRetroAlimentacion" [checked]="retroAlimentacion.seleccionada" [disabled]="this.dataJardin.etapaJardin > 2" *ngIf="dataJardin.etapaJardin>2">
                                                            <span class="span-nombre">{{textoRetroAlimentacion[r]}}</span>
                                                            <span class="span-nota">{{retroAlimentacion.nota}}</span>
                                                        </mat-radio-button>
                                                        <div class="div-contenido">
                                                            <p>{{retroAlimentacion.retroAlimentacion}}</p>
                                                        </div>

                                                    </td>
                                                </tr>
                                            </table>
                                        </mat-radio-group>

                                        <br>
                                        <div style="padding: 2% 3%;" *ngIf="area.nombre==='6'">
                                            <p class="alert-div">DEBIDO A LA DIFICULTAD PARA LA TOMA DE DATOS DURANTE LOS AÑOS 2020 Y 2021, ESTE ELEMENTO DE GESTIÓN NO SERÁ EVALUADO EN EL ACTUAL PROCESO</p>
                                        </div>
                                        <div style="padding: 2% 3%;" *ngIf="area.nombre!='6'">
                                            <div *ngIf="!elemento.retroAlimentacion[0].seleccionada ">
                                                <h3>Medios de Verificación: </h3>

                                                <div class="button-row">
                                                    <button mat-raised-button class="btn-ver" (click)="agregarMedioVerificacion(a, d, e)" [disabled]="this.dataJardin.etapaJardin > 2">
                                                        <i class="fas fa-plus-circle"></i> Agregar Nuevo
                                                    </button>
                                                </div>

                                                <table class="medio-verificacion">
                                                    <tr>
                                                        <th>NÚMERO</th>
                                                        <th>NOMBRE DE MEDIO</th>
                                                        <th>COMENTARIO</th>
                                                        <th>ACCIONES</th>
                                                    </tr>
                                                    <tr *ngFor="let vinculado of elemento.vinculados; let v = index">
                                                        <td>{{v + 1}}</td>
                                                        <td>{{vinculado.nombre}}</td>
                                                        <td>{{vinculado.comentario}}</td>
                                                        <td>
                                                            <img (click)="descargarMedio(vinculado.idMedioVerificacion)" style="width: 35px;margin: 5px;cursor: pointer;" src="../../../.././../../../assets/icons/JUNJI_download.svg">
                                                            <img *ngIf="dataJardin.etapaJardin<=2" (click)="eliminarMedio(vinculado.idMedioVerificacionElementoGestion, a, d, e, v)" style="width: 35px;margin: 5px;cursor: pointer;" src="../../../.././../../../assets/icons/JUNJI_delete.svg">
                                                        </td>
                                                    </tr>
                                                </table>
                                            </div>
                                        </div>

                                    </div>
                                </mat-expansion-panel>
                            </mat-accordion>
                        </div>
                    </mat-tab>
                </mat-tab-group>

            </div>

        </div>
    </div>


</div>
<ngx-spinner></ngx-spinner>